export const ORDER_DUPLICATE_EVENT = "grain-confirm-order-duplicates";
export const ORDER_DUPLICATE_HEADER = "X-Grain-Order-Duplicate-Confirmation";
export const ORDER_DUPLICATE_CODE = "order_duplicates_confirmation_required";

export class OrderDuplicateConfirmationCancelled extends Error {
  constructor() {
    super("Enregistrement annulé. Vous pouvez corriger les commandes.");
    this.name = "OrderDuplicateConfirmationCancelled";
  }
}

export function isOrderDuplicateConfirmationCancelled(error) {
  return error?.name === "OrderDuplicateConfirmationCancelled";
}

export function requestOrderDuplicateConfirmation(challenge) {
  if (typeof window === "undefined") return Promise.resolve(false);
  return new Promise((resolve) => {
    const detail = { challenge, resolve, handled: false };
    window.dispatchEvent(new CustomEvent(ORDER_DUPLICATE_EVENT, { detail }));
    if (!detail.handled) resolve(false);
  });
}

// Retry only this frozen request after an explicit decision. Any newer server
// challenge must be shown again; no blanket "ignore all duplicates" flag.
export async function fetchWithOrderDuplicateConfirmation(fetchImpl, url, init, {
  confirm = requestOrderDuplicateConfirmation,
  onConfirmationChange = null,
} = {}) {
  let nextInit = init;
  for (;;) {
    const response = await fetchImpl(url, nextInit);
    if (response.status !== 409) return response;
    const payload = await response.clone().json().catch(() => null);
    const challenge = payload?.detail;
    if (challenge?.code !== ORDER_DUPLICATE_CODE || !challenge.confirmation_token) return response;
    onConfirmationChange?.(true);
    let accepted;
    try {
      accepted = await confirm(challenge);
    } finally {
      onConfirmationChange?.(false);
    }
    if (!accepted) throw new OrderDuplicateConfirmationCancelled();
    const headers = new Headers(init?.headers);
    headers.set(ORDER_DUPLICATE_HEADER, challenge.confirmation_token);
    nextInit = { ...init, headers };
  }
}
